import React, { useRef } from 'react';
import { useCheckedContextProps } from '@xo-union/tk-component-switches';

import styles from './index.scss';

const SPACE = 32;

export interface Checkable {
  checked: boolean;
}

interface Props {
  onChange?: () => void;
  checked?: boolean;
  id?: string;
  dataTestId: string;
  value: string;
  children: ({ checked }: { checked: boolean }) => React.ReactElement;
}

export const CustomCheckbox: React.FC<Props> = props => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { id, dataTestId, children, ...rest } = props;
  const { value, checked, onChange } = useCheckedContextProps(rest);

  const handleKeyDown = (evt: React.KeyboardEvent<HTMLDivElement>): void => {
    if (evt.keyCode === SPACE) {
      evt.preventDefault();
      const ref = inputRef.current;

      if (ref) {
        ref.click();
      }
    }
  };

  return (
    <div>
      <label htmlFor={id}>
        <div>
          <input
            ref={inputRef}
            className={styles.input}
            type="checkbox"
            value={value}
            checked={checked}
            onChange={onChange}
            id={id}
            data-testid={dataTestId}
          />
          <div onKeyDown={handleKeyDown} tabIndex={0} role="checkbox" aria-checked={checked} aria-labelledby={id}>
            {children && children({ checked })}
          </div>
        </div>
      </label>
    </div>
  );
};
